import { getOwner } from '@ember/application';

export const mapResponseToCollection = (scope, model, response, options) => {
  const store = getOwner(scope).lookup('service:store');

  store.pushPayload(response);
  const data = response.data.map(({ id }) => store.peekRecord(model, id));

  return options?.preserve ? { ...response, data } : data;
};

export const mapResponseToModel = (scope, model, response) => {
  const store = getOwner(scope).lookup('service:store');
  store.pushPayload(response);
  return store.peekRecord(model, response.data.id);
};
